var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.28125,
    cy: 9.28125,
    r: 9.28125,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98271 11.7028H9.18571L8.84936 3.48047H10.3191L9.98271 11.7028ZM8.70312 14.0542C8.70312 13.6909 8.78599 13.4339 8.95173 13.2834C9.11747 13.1277 9.32464 13.0498 9.57324 13.0498C9.81697 13.0498 10.0217 13.1277 10.1874 13.2834C10.3581 13.4339 10.4434 13.6909 10.4434 14.0542C10.4434 14.4124 10.3581 14.6745 10.1874 14.8407C10.0217 15.0016 9.81697 15.082 9.57324 15.082C9.32464 15.082 9.11747 15.0016 8.95173 14.8407C8.78599 14.6745 8.70312 14.4124 8.70312 14.0542Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.b43a79db58e7a4cac889ba9837c336b3.svg";
export { ForwardRef as ReactComponent };